export { default } from './StickyAcquisition';
